import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import TelehealthTherapy from './component/TelehealthTherapy';
import TelehealthModal from './component/TelehealthModal';
import TelehealthServiceQuestions from './component/TelehealthServiceQuestions';

const ResourcesPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Telehealth Pediatric Therapy Wasilla Alaska | Guidepost Telehealth
          Services
        </title>
        <meta
          name="description"
          content="Telehealth pediatric therapy services in Wasilla, Alaska. Access physical, occupational, and speech therapy from the comfort of your home. Convenient and effective therapy made easy."
        />
        <meta
          name="keywords"
          content="telehealth pediatric therapy Wasilla, online therapy Alaska, virtual therapy services, telehealth PT OT SLP Wasilla"
        />
      </Helmet>
      <HeroSection />
      <TelehealthTherapy />
      <TelehealthModal />
      <TelehealthServiceQuestions />
    </div>
  );
};

export default ResourcesPage;
